var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "roomCallVideo",
      staticClass:
        "grm-video-layer one-fourth column flex justify-center items-center",
      attrs: {
        "data-grm-comp": "RoomCallVideo.p2p",
        "data-user-id": _vm.user.userId,
        "data-screen-share": _vm.user.screenShare,
      },
      on: { click: _vm.onClick },
    },
    [
      _c("StopWatch", { attrs: { user: _vm.user } }),
      _c(
        "div",
        { ref: "roomVideoWrapper", staticClass: "relative w-full h-full" },
        [
          _vm.stream
            ? _c("RoomVideo", {
                ref: "video",
                staticClass: "grm-video",
                style: _vm.roomVideoStyle,
                attrs: {
                  muted: true,
                  videoOnly: _vm.videoOnly,
                  myVideo: _vm.isMe,
                },
                on: {
                  resize: _vm.onRoomVideoResize,
                  playing: _vm.onRoomVideoResize,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      !_vm.isScreenShare
        ? _c(
            "div",
            {
              staticClass: "v-bg",
              class: {
                "no-cam":
                  (!!_vm.roomUser &&
                    _vm.roomUser.roomUserRole.camera == false) ||
                  _vm.roomUser.cameraStatus != "on",
                "no-user": !_vm.roomUser,
              },
            },
            [
              !_vm.roomUser
                ? _c("img", {
                    staticClass: "pointer-events-none",
                    style:
                      _vm.ux.useNoneVideoImageFull && _vm.ux.noneVideoImagePath
                        ? {
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }
                        : {
                            height: "40%",
                          },
                    attrs: {
                      src:
                        _vm.ux.noneVideoImagePath ||
                        require("@/assets/roomType/lms/img/v-img/user1.svg"),
                    },
                  })
                : _vm._e(),
            ]
          )
        : _vm._e(),
      !!_vm.roomUser
        ? [
            _c("div", {
              staticClass: "v-peakmeter",
              class: {
                active:
                  _vm.roomUser && _vm.roomUser.isSpeaking && !_vm.isScreenShare,
              },
            }),
            !_vm.isScreenShare ? _c("div", { staticClass: "v-dim" }) : _vm._e(),
            _c("div", { staticClass: "v-name-area" }, [
              _c(
                "div",
                {
                  staticClass: "v-name ep flex items-center",
                  class: { isMe: _vm.isMe },
                },
                [
                  _vm.isOpener(_vm.roomUser.userId)
                    ? _c("GrmIcon", {
                        staticClass: "mr-1",
                        attrs: { icon: "opener" },
                      })
                    : _vm._e(),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: _vm.roomUser.nickname,
                          expression: "roomUser.nickname",
                          modifiers: { top: true },
                        },
                      ],
                      staticClass:
                        "room-user-nickname min-w-0 max-w-max flex-1 truncate",
                    },
                    [_vm._v(_vm._s(_vm.roomUser.nickname))]
                  ),
                ],
                1
              ),
            ]),
            _c("RoomSticker", {
              staticClass: "absolute inset-0",
              attrs: { "sticker-id": _vm.roomUser.stickerId },
            }),
          ]
        : _vm._e(),
      _vm.user.screenShare
        ? _c("RoomCallScreenShare", { attrs: { userId: _vm.user.userId } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }